import { Chip, GridColDef } from 'ui';

import { SelectedInspector } from '../../types';

export const columns: GridColDef<SelectedInspector>[] = [
  {
    field: 'name',
    flex: 1,
    headerName: 'Name',
  },
  {
    field: 'Company',
    flex: 1,
    valueGetter: (params) => {
      if (!params.row?.company) {
        return 'N/A';
      }
      return String(params.row.company.name);
    },
  },
  {
    field: 'is_active',
    flex: 1,
    headerName: 'Status',
    renderCell: (params) => {
      return (
        <Chip
          color={params.value ? 'success' : 'error'}
          variant="outlined"
          label={params.value ? 'Active' : 'Inactive'}
        />
      );
    },
  },
  {
    field: 'email',
    flex: 1,
    headerName: 'Email',
  },
  {
    field: 'phone_number',
    flex: 1,
    headerName: 'Phone Number',
  },
];
